import { Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { AddButtonLink } from '@/core/components';

import { ReclaimableAuthorList } from '@feature/utils/components/ReclaimableAuthorList';

import { PublicationReclaimSearch, ReclaimRequest } from './model/PublicationTypes';

interface PublicationFoundModalProps {
  close: () => void;
  data: PublicationReclaimSearch;

  onReclaimAuthorship: (v: ReclaimRequest) => void;
}

export function PublicationFoundModal({ close, data, onReclaimAuthorship }: PublicationFoundModalProps) {
  const { publication } = data;
  const { t } = useTranslation();

  return (
    <Modal
      opened
      onClose={close}
      centered
      size="lg"
      title={publication != null && t('publications.foundPub')}
    >
      {publication == null && (
        <Stack>
          <Text ta="center">{t('publications.notSearchFound')}</Text>
          <AddButtonLink
            to="../create"
            name={t('button.addNew')}
          />
        </Stack>
      )}
      {publication != null && (
        <Stack>
          <Text fw="500">{publication.title}</Text>
          <ReclaimableAuthorList
            authors={publication.authors}
            onReclaim={authorId => onReclaimAuthorship({ authorId, publicationId: publication.id })}
          />
        </Stack>
      )}
    </Modal>
  );
}
